import React from "react";
import Text from "@streeteasy/design-system/deprecated/Text";
import { node, string } from "prop-types";

import * as S from "./styled";

const TooltipTrigger = ({ title }) => (
  <>
    <S.Trigger />
    <S.HiddenLabel>{title}</S.HiddenLabel>
  </>
);

TooltipTrigger.propTypes = {
  title: string.isRequired
};

const TooltipContent = ({ children, title }) => (
  <S.TooltipContent>
    <S.TooltipTitle>{title}</S.TooltipTitle>
    <Text type="sm">{children}</Text>
  </S.TooltipContent>
);

TooltipContent.propTypes = {
  title: string.isRequired,
  children: node.isRequired
};

const Tooltip = ({ children, title }) => (
  <>
    <S.DesktopTooltip triggerNode={<TooltipTrigger title={title} />}>
      <TooltipContent title={title}>{children}</TooltipContent>
    </S.DesktopTooltip>
    <S.MobileTooltip triggerNode={<TooltipTrigger title={title} />}>
      <TooltipContent title={title}>{children}</TooltipContent>
    </S.MobileTooltip>
  </>
);

Tooltip.propTypes = {
  title: string.isRequired,
  children: node.isRequired
};

export default Tooltip;
